import React, { useEffect, useState } from 'react';
import { useAppStore } from '../context/AppStore';
import { Card, Button, Badge, NetworkIcon, EmptyState, ConfirmDialog } from '../components/ui';
import { NETWORK_CONFIG } from '../api/mockData';
import { accountsAPI, billingAPI } from '../api/client';
import api from '../api/client';
import toast from 'react-hot-toast';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const PRO_ONLY_NETWORKS = ['gmail', 'google_calendar'];

function ConnectButtons({ oauthEnabled, onManual }) {
  const [individualPlanSlug, setIndividualPlanSlug] = useState(null);

  useEffect(() => {
    billingAPI.individualPlan().then(r => setIndividualPlanSlug(r.data?.slug || null)).catch(() => {});
  }, []);

  const hasProAccess = individualPlanSlug === 'pro' || individualPlanSlug === 'agency';

  const handleOAuth = (network) => {
    if (network === 'gmail') {
      const token = localStorage.getItem('access_token');
      window.location.href = `${API_BASE}/email/gmail/oauth?token=${token}`;
      return;
    }
    const token = localStorage.getItem('access_token');
    window.location.href = `${API_BASE}/accounts/${network}/oauth?token=${token}`;
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '4px' }}>Selecciona la red social que deseas conectar:</p>
      {Object.entries(NETWORK_CONFIG).map(([key, cfg]) => {
        const isProOnly = PRO_ONLY_NETWORKS.includes(key);
        const isLockedForUser = isProOnly && individualPlanSlug !== null && !hasProAccess;
        return (
          <div key={key} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', background: 'var(--bg-elevated)', opacity: isLockedForUser ? 0.6 : 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <NetworkIcon network={key} size={32} />
              <div>
                <div style={{ fontWeight: '700', fontSize: '14px' }}>{cfg.name}</div>
                <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                  {isLockedForUser
                    ? 'Requiere tu propio plan Pro o Agency'
                    : (oauthEnabled[key] ? 'OAuth 2.0 listo' : 'Token manual · Configura en Settings → Integraciones')}
                </div>
              </div>
            </div>
            {isLockedForUser ? (
              <Button size="sm" variant="secondary" disabled icon="🔒">Bloqueado</Button>
            ) : oauthEnabled[key] ? (
              <Button size="sm" onClick={() => handleOAuth(key)} icon="🔗">Conectar</Button>
            ) : (
              <Button size="sm" variant="secondary" onClick={() => onManual(key)}>Token manual</Button>
            )}
          </div>
        );
      })}
    </div>
  );
}

function ManualTokenForm({ network, onSave, onCancel, loading }) {
  const cfg = NETWORK_CONFIG[network] || {};
  const [name, setName] = useState('');
  const [token, setToken] = useState('');
  const [showToken, setShowToken] = useState(false);
  const hints = {
    instagram: 'Meta for Developers → Graph API Explorer → Generar token',
    facebook: 'Meta for Developers → Graph API Explorer → Page Access Token',
    twitter: 'developer.twitter.com → Keys and Tokens',
    linkedin: 'developer.linkedin.com → OAuth 2.0 tools',
    youtube: 'Google Cloud Console → APIs → OAuth 2.0',
    tiktok: 'developers.tiktok.com → Manage apps → Auth Token',
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: `${cfg.color}10`, borderRadius: 'var(--radius-md)', border: `1px solid ${cfg.color}30` }}>
        <NetworkIcon network={network} size={28} />
        <span style={{ fontWeight: '700', color: cfg.color }}>{cfg.name}</span>
        <Badge color="#f59e0b">Token manual</Badge>
      </div>
      <div>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '6px' }}>Nombre / @usuario</label>
        <input value={name} onChange={e => setName(e.target.value)} placeholder="@miempresa" style={{ width: '100%', background: 'var(--bg-elevated)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)', fontFamily: 'var(--font-body)', fontSize: '14px', padding: '10px 12px', outline: 'none', boxSizing: 'border-box' }} />
      </div>
      <div style={{ position: 'relative' }}>
        <label style={{ fontSize: '13px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '6px' }}>Access Token</label>
        <input value={token} onChange={e => setToken(e.target.value)} type={showToken ? 'text' : 'password'} placeholder="Token de acceso" style={{ width: '100%', background: 'var(--bg-elevated)', border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', color: 'var(--text-primary)', fontFamily: 'var(--font-body)', fontSize: '14px', padding: '10px 40px 10px 12px', outline: 'none', boxSizing: 'border-box' }} />
        <button type="button" onClick={() => setShowToken(!showToken)} style={{ position: 'absolute', right: '10px', top: '32px', background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '16px' }}>{showToken ? '🙈' : '👁'}</button>
      </div>
      <div style={{ padding: '10px 12px', background: 'var(--bg-elevated)', borderRadius: 'var(--radius-md)', border: '1px solid var(--border)', fontSize: '12px', color: 'var(--text-muted)' }}>
        💡 {hints[network]}
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <Button variant="ghost" onClick={onCancel}>Cancelar</Button>
        <Button loading={loading} onClick={() => {
          if (!name || !token) { toast.error('Nombre y token requeridos'); return; }
          onSave({ network, name, account_type: 'personal', access_token: token, followers: 0 });
        }}>Guardar token</Button>
      </div>
    </div>
  );
}

// Tarjeta: animación solo ocurre cuando removing=true (post-confirmación)
function AccountCard({ acc, onDisconnect, removing }) {
  const cfg = NETWORK_CONFIG[acc.network];
  return (
    <div style={{
      transition: 'opacity 0.35s ease, transform 0.35s ease, max-height 0.4s ease, margin 0.4s ease',
      opacity: removing ? 0 : 1,
      transform: removing ? 'translateX(40px) scale(0.97)' : 'translateX(0) scale(1)',
      maxHeight: removing ? '0' : '120px',
      overflow: 'hidden',
      marginBottom: removing ? '0' : undefined,
    }}>
      <Card style={{ padding: '14px 18px', marginBottom: '2px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <div style={{ position: 'relative' }}>
            <NetworkIcon network={acc.network} size={40} />
            <div style={{ position: 'absolute', bottom: '-2px', right: '-2px', width: '12px', height: '12px', borderRadius: '50%', background: '#10b981', border: '2px solid var(--bg-card)' }} />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{ fontWeight: '700', fontSize: '14px' }}>{acc.name}</span>
              <Badge color={cfg?.color}>{acc.account_type}</Badge>
              <Badge color="#10b981">Conectado</Badge>
            </div>
            <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '3px' }}>
              {cfg?.name} · {acc.followers > 0 ? `${acc.followers.toLocaleString('es')} seguidores` : 'Sin datos de seguidores'}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
            <Button variant="danger" size="sm" onClick={() => onDisconnect(acc)}>Desconectar</Button>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default function AccountsPage() {
  const { accounts, accountsLoading, fetchAccounts, removeAccount } = useAppStore();
  const [oauthEnabled, setOauthEnabled] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [manualNetwork, setManualNetwork] = useState(null);
  const [disconnecting, setDisconnecting] = useState(null);
  const [removingId, setRemovingId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [expiring, setExpiring] = useState([]);
  const [gmailAccounts, setGmailAccounts] = useState([]);
  const [mainIndividualPlanSlug, setMainIndividualPlanSlug] = useState(null);

  useEffect(() => {
    billingAPI.individualPlan().then(r => setMainIndividualPlanSlug(r.data?.slug || null)).catch(() => {});
  }, []);
  const [smtpAccounts, setSmtpAccounts] = useState([]);
  const [showSmtpModal, setShowSmtpModal] = useState(false);
  const [smtpForm, setSmtpForm] = useState({ email: '', smtp_host: '', smtp_port: 587, smtp_password: '' });
  const [smtpSaving, setSmtpSaving] = useState(false);
  const [smtpTesting, setSmtpTesting] = useState(false);

  useEffect(() => {
    fetchAccounts();
    api.get('/accounts/check-expiry').then(r => setExpiring(r.data)).catch(() => {});
    const tk = localStorage.getItem('access_token');
    if (tk) api.get(`/email/accounts?token=${tk}`).then(r => setGmailAccounts(r.data.filter(a => a.provider !== 'smtp'))).catch(() => {});
    if (tk) api.get(`/email/accounts?token=${tk}`).then(r => setSmtpAccounts(r.data.filter(a => a.provider === 'smtp'))).catch(() => {});
    api.get('/integrations').then(({ data }) => {
      const map = {};
      data.forEach(d => { if (d.is_enabled) map[d.network] = true; });
      if (map['instagram']) map['facebook'] = true;
      setOauthEnabled(map);
    }).catch(() => {});

    const params = new URLSearchParams(window.location.search);
    const connected = params.get('connected');
    const emailConnected = params.get('email_connected');
    if (emailConnected) {
      toast.success(`Gmail conectado ✓`);
    }
    if (connected) {
      toast.success(`Cuenta de ${connected} conectada ✓`);
      window.history.replaceState({}, '', window.location.pathname);
      fetchAccounts();
    }
  }, []);

  const handleSaveManual = async (form) => {
    setSaving(true);
    try {
      await accountsAPI.connect(form.network, { network: form.network, name: form.name, account_type: form.account_type, access_token: form.access_token, followers: 0 });
      await fetchAccounts();
      setManualNetwork(null);
      setShowModal(false);
      toast.success(`Cuenta ${form.name} conectada ✓`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Error al conectar cuenta');
    } finally { setSaving(false); }
  };

  const handleTestSmtp = async () => {
    setSmtpTesting(true);
    try {
      const { data } = await api.post('/email/smtp/test', smtpForm);
      if (data.ok) toast.success('✅ Conexión exitosa');
      else toast.error(`Error: ${data.error}`);
    } catch (e) {
      toast.error('Error probando conexión');
    } finally { setSmtpTesting(false); }
  };

  const handleConnectSmtp = async () => {
    if (!smtpForm.email || !smtpForm.smtp_host || !smtpForm.smtp_password) {
      toast.error('Completa todos los campos');
      return;
    }
    setSmtpSaving(true);
    try {
      const tk = localStorage.getItem('access_token');
      await api.post(`/email/smtp/connect?token=${tk}`, smtpForm);
      toast.success('Correo corporativo conectado ✓');
      setShowSmtpModal(false);
      setSmtpForm({ email: '', smtp_host: '', smtp_port: 587, smtp_password: '' });
      const r = await api.get(`/email/accounts?token=${tk}`);
      setSmtpAccounts(r.data.filter(a => a.provider === 'smtp'));
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Error conectando correo');
    } finally { setSmtpSaving(false); }
  };

  const handleConfirmDisconnect = async () => {
    const id = disconnecting?.id;
    setDisconnecting(null);
    // 1. Activa animación de salida
    setRemovingId(id);
    // 2. Espera que termine la animación, luego llama al backend
    setTimeout(async () => {
      try {
        await removeAccount(id);
        toast.success('Cuenta desconectada');
      } catch {
        toast.error('Error al desconectar');
      } finally {
        setRemovingId(null);
        await fetchAccounts();
      }
    }, 380);
  };

  const connected = accounts.filter(a => a.is_connected);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {expiring.length > 0 && (
        <div className="animate-fadeIn" style={{ padding: '14px 18px', borderRadius: 'var(--radius-lg)', background: '#ef444410', border: '1px solid #ef444430', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <span style={{ fontSize: '20px', flexShrink: 0 }}>⚠️</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: '700', fontSize: '14px', color: '#ef4444', marginBottom: '6px' }}>
              {expiring.length} cuenta{expiring.length > 1 ? 's' : ''} requiere{expiring.length > 1 ? 'n' : ''} reconexión
            </div>
            {expiring.map(acc => (
              <div key={acc.id} style={{ fontSize: '13px', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                <NetworkIcon network={acc.network} size={16} />
                <span>{acc.name}</span>
                <span style={{ fontSize: '11px', color: '#ef4444' }}>— {acc.reason}</span>
              </div>
            ))}
            <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '6px' }}>Reconecta las cuentas afectadas para continuar publicando.</p>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>{connected.length} cuentas conectadas</p>
        <Button icon="+" onClick={() => { setManualNetwork(null); setShowModal(true); }}>Conectar cuenta</Button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '12px' }}>
        {Object.entries(NETWORK_CONFIG).map(([key, cfg]) => {
          const count = accounts.filter(a => a.network === key && a.is_connected).length;
          const isProOnlyCard = ['gmail', 'google_calendar'].includes(key);
          const isLockedCard = isProOnlyCard && mainIndividualPlanSlug !== null && mainIndividualPlanSlug !== 'pro' && mainIndividualPlanSlug !== 'agency';
          return (
            <div key={key} style={{ padding: '14px', borderRadius: 'var(--radius-lg)', background: count > 0 ? `${cfg.color}10` : 'var(--bg-elevated)', border: `1px solid ${count > 0 ? cfg.color + '40' : 'var(--border)'}`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', textAlign: 'center', opacity: isLockedCard ? 0.55 : 1, position: 'relative' }}>
              {isLockedCard && <span style={{ position: 'absolute', top: '8px', right: '8px', fontSize: '13px' }}>🔒</span>}
              <NetworkIcon network={key} size={32} />
              <span style={{ fontSize: '12px', fontWeight: '600', color: count > 0 ? cfg.color : 'var(--text-muted)' }}>{cfg.name}</span>
              {isLockedCard
                ? <Badge color="#555">Plan Pro/Agency</Badge>
                : <Badge color={count > 0 ? cfg.color : '#555'}>{count} activa{count !== 1 ? 's' : ''}</Badge>}
            </div>
          );
        })}
        {(() => {
          const isSmtpLocked = mainIndividualPlanSlug !== null && mainIndividualPlanSlug !== 'pro' && mainIndividualPlanSlug !== 'agency';
          return (
            <div
              onClick={() => { if (!isSmtpLocked) setShowSmtpModal(true); }}
              style={{ cursor: isSmtpLocked ? 'not-allowed' : 'pointer', padding: '14px', borderRadius: 'var(--radius-lg)', background: smtpAccounts.length > 0 ? '#6366f110' : 'var(--bg-elevated)', border: `1px solid ${smtpAccounts.length > 0 ? '#6366f140' : 'var(--border)'}`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', textAlign: 'center', opacity: isSmtpLocked ? 0.55 : 1, position: 'relative' }}
            >
              {isSmtpLocked && <span style={{ position: 'absolute', top: '8px', right: '8px', fontSize: '13px' }}>🔒</span>}
              <span style={{ fontSize: '32px' }}>📧</span>
              <span style={{ fontSize: '12px', fontWeight: '600', color: smtpAccounts.length > 0 ? '#6366f1' : 'var(--text-muted)' }}>Correo corporativo</span>
              {isSmtpLocked
                ? <Badge color="#555">Plan Pro/Agency</Badge>
                : <Badge color={smtpAccounts.length > 0 ? '#6366f1' : '#555'}>{smtpAccounts.length} activa{smtpAccounts.length !== 1 ? 's' : ''}</Badge>}
            </div>
          );
        })()}
      </div>

      {accountsLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {[...Array(3)].map((_, i) => <div key={i} className="skeleton" style={{ height: '80px', borderRadius: 'var(--radius-lg)' }} />)}
        </div>
      ) : connected.length === 0 ? (
        <EmptyState icon="📱" title="Sin cuentas conectadas" description="Conecta tus redes sociales para empezar a publicar automáticamente." action={<Button icon="+" onClick={() => setShowModal(true)}>Conectar primera cuenta</Button>} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {smtpAccounts.map((sAcc) => (
            <div key={sAcc.id} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '28px' }}>📧</span>
                <div>
                  <div style={{ fontWeight: '700', fontSize: '14px' }}>{sAcc.email}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Correo corporativo (SMTP) · Conectado</div>
                </div>
              </div>
              <button onClick={async () => { const tk = localStorage.getItem('access_token'); await api.delete(`/email/accounts/${sAcc.id}?token=${tk}`); setSmtpAccounts(prev => prev.filter(a => a.id !== sAcc.id)); }} style={{ background: '#ef444415', border: '1px solid #ef444430', color: '#ef4444', cursor: 'pointer', padding: '6px 14px', borderRadius: '8px', fontSize: '12px' }}>Desconectar</button>
            </div>
          ))}
          {gmailAccounts.map((gAcc) => (
            <div key={gAcc.id} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '28px' }}>📧</span>
                <div>
                  <div style={{ fontWeight: '700', fontSize: '14px' }}>{gAcc.email}</div>
                  <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Gmail · Conectado</div>
                </div>
              </div>
              <button onClick={async () => { const tk = localStorage.getItem('access_token'); await api.delete(`/email/accounts/${gAcc.id}?token=${tk}`); setGmailAccounts(prev => prev.filter(a => a.id !== gAcc.id)); }} style={{ background: '#ef444415', border: '1px solid #ef444430', color: '#ef4444', cursor: 'pointer', padding: '6px 14px', borderRadius: '8px', fontSize: '12px' }}>Desconectar</button>
            </div>
          ))}
          {connected.map((acc) => (
            <AccountCard
              key={acc.id}
              acc={acc}
              removing={removingId === acc.id}
              onDisconnect={(a) => setDisconnecting(a)}
            />
          ))}
        </div>
      )}

      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: '#00000080', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }} onClick={() => { setShowModal(false); setManualNetwork(null); }}>
          <div style={{ background: 'var(--bg-card)', borderRadius: 'var(--radius-xl)', padding: '28px', width: '100%', maxWidth: '520px', maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: '700' }}>
                {manualNetwork ? `Conectar ${NETWORK_CONFIG[manualNetwork]?.name}` : 'Conectar red social'}
              </h2>
              <button onClick={() => { setShowModal(false); setManualNetwork(null); }} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '20px' }}>✕</button>
            </div>
            {manualNetwork
              ? <ManualTokenForm network={manualNetwork} onSave={handleSaveManual} onCancel={() => setManualNetwork(null)} loading={saving} />
              : <ConnectButtons oauthEnabled={oauthEnabled} onManual={net => setManualNetwork(net)} />
            }
          </div>
        </div>
      )}

      {showSmtpModal && (
        <div style={{ position: 'fixed', inset: 0, background: '#00000080', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }} onClick={() => setShowSmtpModal(false)}>
          <div style={{ background: 'var(--bg-card)', borderRadius: 'var(--radius-xl)', padding: '28px', width: '100%', maxWidth: '480px' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: '700' }}>📧 Conectar correo corporativo</h2>
              <button onClick={() => setShowSmtpModal(false)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '20px' }}>✕</button>
            </div>
            <p style={{ fontSize: '13px', color: 'var(--text-muted)', marginBottom: '18px' }}>
              Conecta tu correo de Outlook, Zoho, cPanel o cualquier proveedor con SMTP. Se usará para notificaciones de reservas, CRM y citas.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px' }}>Correo electrónico</label>
                <input style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: '#fff', fontSize: '13px' }} value={smtpForm.email} onChange={e => setSmtpForm(p => ({ ...p, email: e.target.value }))} placeholder="ventas@tuempresa.com" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '10px' }}>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px' }}>Servidor SMTP (host)</label>
                  <input style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: '#fff', fontSize: '13px' }} value={smtpForm.smtp_host} onChange={e => setSmtpForm(p => ({ ...p, smtp_host: e.target.value }))} placeholder="mail.tuempresa.com" />
                </div>
                <div>
                  <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px' }}>Puerto</label>
                  <input type="number" style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: '#fff', fontSize: '13px' }} value={smtpForm.smtp_port} onChange={e => setSmtpForm(p => ({ ...p, smtp_port: parseInt(e.target.value) || 587 }))} />
                </div>
              </div>
              <div>
                <label style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)', display: 'block', marginBottom: '5px' }}>Contraseña</label>
                <input type="password" style={{ width: '100%', padding: '10px 12px', borderRadius: '8px', background: 'var(--bg-elevated)', border: '1px solid var(--border)', color: '#fff', fontSize: '13px' }} value={smtpForm.smtp_password} onChange={e => setSmtpForm(p => ({ ...p, smtp_password: e.target.value }))} placeholder="••••••••" />
              </div>
              <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
                <Button variant="ghost" onClick={handleTestSmtp} loading={smtpTesting} style={{ flex: 1 }}>🔍 Probar conexión</Button>
                <Button onClick={handleConnectSmtp} loading={smtpSaving} style={{ flex: 1 }}>Conectar</Button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ConfirmDialog
        open={!!disconnecting}
        onClose={() => setDisconnecting(null)}
        onConfirm={handleConfirmDisconnect}
        title="Desconectar cuenta"
        message={`¿Desconectar ${disconnecting?.name}? No podrás publicar en esta cuenta hasta reconectarla.`}
        confirmLabel="Desconectar"
        danger
      />
    </div>
  );
}
